// app/javascript/controllers/bulk_invites_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["select", "button"]
    static values = {
        url: String,
        flashTarget: String
    }

    connect() {
        this._onChange = () => this.enableOrDisable()
        if (this.hasSelectTarget) {
            this.selectTarget.addEventListener("change", this._onChange)
            this.selectTarget.addEventListener("addItem", this._onChange)   // Choices.js event
            this.selectTarget.addEventListener("removeItem", this._onChange) // (paranoia)
        }
        this.enableOrDisable()
        this.buttonTarget.addEventListener("click", (e) => this.onClick(e))
    }

    disconnect() {
        if (this.hasSelectTarget) {
            this.selectTarget.removeEventListener("change", this._onChange)
            this.selectTarget.removeEventListener("addItem", this._onChange)
            this.selectTarget.removeEventListener("removeItem", this._onChange)
        }
    }

    enableOrDisable() {
        const val = (this.hasSelectTarget ? this.selectTarget.value : "").trim()
        if (this.hasButtonTarget) this.buttonTarget.disabled = (val === "")
    }

    onChange() {
        this.enableOrDisable()
    }

    onClick(e) {
        e.preventDefault()
        const group = this.selectTarget.value
        if (!group) return

        const human =
            group === "unsent"  ? "all unsent guests" :
                group === "noreply" ? "guests who haven’t replied yet" :
                    "everyone"

        // Confirm with Swal (your swal controller auto-hooks on data attributes)
        import("sweetalert2").then(({ default: Swal }) => {
            Swal.fire({
                icon: "question",
                title: "Send invitations?",
                html: `This will send invitations to <b>${human}</b>.`,
                showCancelButton: true,
                confirmButtonText: "Yes, send",
                cancelButtonText: "Cancel"
            }).then(result => {
                if (!result.isConfirmed) return

                // Disable while sending
                this.buttonTarget.disabled = true
                const originalText = this.buttonTarget.textContent
                this.buttonTarget.textContent = "Sending…"

                const fd = new FormData()
                fd.append("group", group)
                fd.append("flash_target", this.flashTargetValue || "guests-flash")

                fetch(this.urlValue, {
                    method: "POST",
                    headers: {
                        "Accept": "text/vnd.turbo-stream.html",
                        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
                    },
                    body: fd
                })
                    .then(r => r.text())
                    .then(html => {
                        // Let Turbo process stream
                        if (window.Turbo?.renderStreamMessage) {
                            Turbo.renderStreamMessage(html)
                        } else {
                            // fallback: append to body
                            const div = document.createElement("div")
                            div.innerHTML = html
                            document.body.appendChild(div)
                        }
                    })
                    .finally(() => {
                        this.buttonTarget.textContent = originalText
                    })
            })
        })
    }
}